import React from 'react';
import { Calendar, Clock, MapPin, Target } from 'lucide-react';

export const Program = () => {
  const features = [
    { icon: <Calendar size={24} />, label: 'Dauer', value: '12 Wochen' },
    { icon: <Clock size={24} />, label: 'Trainingszeit', value: '3× 30 Min/Woche' },
    { icon: <MapPin size={24} />, label: 'Ort', value: 'Überall durchführbar' },
    { icon: <Target size={24} />, label: 'Fokus', value: 'Haltung & Stabilität' }
  ];

  const focuses = [
    'Haltungskorrektur',
    'Rumpfstabilität',
    'Hüftmobilität',
    'Rückenstärkung',
    'Schultermobilität',
    'Atemtechnik',
    'Bewegungsqualität'
  ];

  return (
    <section id="programm" style={{
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-subtle)'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Das Haltung-Reset Programm
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Ein strukturiertes 12-Wochen-Programm, das deine Haltung von Grund auf neu aufbaut.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 'var(--spacing-medium)',
          marginBottom: 'var(--spacing-xl)'
        }}>
          {features.map((feature, index) => (
            <div key={index} style={{
              background: 'var(--bg-card)',
              padding: 'var(--spacing-large)',
              borderRadius: '24px',
              textAlign: 'center',
              boxShadow: '0 2px 8px rgba(0, 69, 52, 0.15)'
            }}>
              <div style={{
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-small)',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {feature.icon}
              </div>
              <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '4px' }}>
                {feature.label}
              </div>
              <div className="heading-3">{feature.value}</div>
            </div>
          ))}
        </div>

        <div className="network-card" style={{ cursor: 'default' }}>
          <h3 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)', textAlign: 'center' }}>
            Trainingsfokus
          </h3>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 'var(--spacing-small)',
            justifyContent: 'center'
          }}>
            {focuses.map((focus, index) => (
              <div key={index} style={{
                padding: '12px 24px',
                background: 'var(--bg-subtle)',
                borderRadius: '20px',
                fontSize: 'clamp(0.875rem, 1.5vw, 1rem)',
                fontWeight: 500,
                color: 'var(--text-primary)'
              }}>
                {focus}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};